export enum COLAB_USER_ORIGIN {
  /** form_iframe / default — public occurrence form embedded in the city's own site */
  FORM_IFRAME_DEFAULT = 9,
}
